import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { selectIsUserLoggedOut, selectUser } from 'redux/auth';
import { anonymousLogin, logout } from 'redux/auth/authActions';
import { exists } from 'lib/types';
import { isAnonymousFlow } from '../helpers/anonymousFlow';

export function usePlacementAnonymousLogin() {
  const dispatch = useAppDispatch();
  const [startedFromAnonymousFlow, setStartedFromAnonymousFlow] =
    useState(false);
  const isLoggedOut = useAppSelector(selectIsUserLoggedOut);
  const user = useAppSelector(selectUser);
  const isAnonymousLogin = isAnonymousFlow();

  useEffect(() => {
    // A signed-in, non-anonymous session that never finished registration must be logged
    // out so it falls back into the anonymous flow instead of skipping customer validation
    if (
      !isLoggedOut &&
      !isAnonymousLogin &&
      exists(user) &&
      !user.data().postRegistrationComplete
    ) {
      void dispatch(logout());
      return;
    }

    // If no user is logged in, create an anonymous login
    if (isLoggedOut) {
      void dispatch(anonymousLogin());
    }

    // Track if the user started out as an anonymous login so we can adjust the UI conditionally
    if (!isLoggedOut && isAnonymousLogin) {
      setStartedFromAnonymousFlow(true);
    }
  }, [isLoggedOut, isAnonymousLogin, user]);

  return { startedFromAnonymousFlow };
}
